import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  coordsWrapper: {
    padding: `0px ${SPACES.xxl}`,
    display: 'flex',
    justifyContent: 'space-between',
    gap: SPACES.xxl,
    marginBottom: SPACES.xs,
  },
  root: {
    width: '100%',
    height: 400,
    borderRadius: 10,
    overflow: 'hidden',
  },
  coordInput: {
    '&&': {
      [theme.breakpoints.down('laptop')]: {
        fontSize: FONTS.SIZES.s,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.m,
      },
    },
  },
}))
